import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { catchError, map, tap, finalize } from "rxjs/operators";
import { CookieService } from "ngx-cookie";

import { Cookie } from "../core/cookie/cookie.enum";
import { EndPointService } from "../core/end-point/end-point.service";
import { EndPointSignature } from "../core/end-point/end-point-signature.enum";
import { UtilityService } from "../core/utility/utility.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  private token: string | undefined;
  public model = { username: undefined, password: undefined };
  public errorMsg: string;

  constructor(
    private cookieService: CookieService,
    private endPointService: EndPointService,
    private utilityService: UtilityService
  ) {}

  ngOnInit() {
    this.token = this.cookieService.get(Cookie.CookieName);

    if (this.token) {
      this.utilityService.loadingEmitChange(true);
      this.endPointService
        .service(EndPointSignature.ValidateToken, {}, this.token)
        .pipe(
          tap(
            // Log the result or error
            (data) => {
              this.utilityService.redirectToServicePage();
            },
            (error) => console.log(error)
          ),
          finalize(() => {
            this.utilityService.loadingEmitChange(false);
          })
        )
        .subscribe();
    }
  }

  onSubmit() {
    this.errorMsg = undefined;
    this.utilityService.loadingEmitChange(true);
    this.endPointService
      .service(EndPointSignature.AuthenticateUser, this.model)
      .pipe(
        tap(
          // Log the result or error
          (data) => {
            this.cookieService.put(Cookie.CookieName, <string>data, {
              expires: Cookie.CookieExpiry,
              path: "/",
              domain: Cookie.CookieDomain,
            });
            this.utilityService.redirectToServicePage();
          },
          (err) => (this.errorMsg = err.error)
        ),
        finalize(() => {
          this.utilityService.loadingEmitChange(false);
        })
      )
      .subscribe();
  }
}
